import { CtaAction, ctaActionFromString } from './ctaAction'

// MOBD-66: adaptadores puros (sin React) del contrato de bloqueo de usuario del backend.
//
// El backend, cuando rechaza una acción por el estado del CLIENTE (datos de facturación
// incompletos, documentación caducada, KYC pendiente, impago...), añade un objeto `block` a la
// respuesta de error. Estas apps son de OPERADOR: el copy (title/reason/solution/cta.label) ya
// viene redactado por el backend explicando por qué el cliente está bloqueado y qué debe hacer;
// aquí solo se normaliza y se decide qué hace el botón de la acción.

// resolveBlock(error) -> forma normalizada estable, o null si la respuesta NO trae bloque
// (éxito, o error de un endpoint aún no migrado). Cuando devuelve null, el llamador sigue con su
// copy tradicional (error.mes), de modo que el cambio es puramente aditivo.
export function resolveBlock(error) {
    const block = error && error.block
    if (!block) return null
    const cta = block.cta || {}
    return {
        code: block.code != null ? block.code : null,
        title: block.title != null ? block.title : null,
        reason: block.reason != null ? block.reason : null,
        solution: block.solution != null ? block.solution : null,
        ctaAction: ctaActionFromString(cta.action),
        ctaLabel: cta.label != null ? cta.label : null,
        // retriable solo si es exactamente true: un string "true" u otro valor no cuenta.
        retriable: block.retriable === true,
        audience: block.audience != null ? block.audience : null,
    }
}

// ctaHandlerFor(ctaAction, navigate, ctx) -> función a ejecutar al pulsar el botón de la acción.
//
// En apps de operador la mayoría de acciones del contrato son cosas que solo el CLIENTE puede
// hacer (aceptar condiciones, subir KYC, añadir tarjeta): el operador no tiene pantalla
// equivalente, así que por defecto la acción es descartar el aviso (ctx.dismiss). Se admiten dos
// puntos de extensión opcionales:
//   - ctx.routes[action]: si se define una ruta para la acción, se navega a ella y se descarta.
//   - ctx.retry / ctx.contactSupport: handlers para RETRY y CONTACT_SUPPORT.
// Cualquier acción desconocida (NONE incluida) sin ruta ni handler => descartar.
export function ctaHandlerFor(ctaAction, navigate, ctx = {}) {
    const dismiss = typeof ctx.dismiss === 'function' ? ctx.dismiss : () => {}
    const action = ctaActionFromString(ctaAction)

    const route = ctx.routes && ctx.routes[action]
    if (route && typeof navigate === 'function') {
        return () => {
            navigate(route)
            dismiss()
        }
    }
    if (action === CtaAction.RETRY && typeof ctx.retry === 'function') {
        return ctx.retry
    }
    if (
        action === CtaAction.CONTACT_SUPPORT &&
        typeof ctx.contactSupport === 'function'
    ) {
        return ctx.contactSupport
    }
    return dismiss
}
